export default [
  {
    // 企业信息填写页
    // 如果是 mid 已经是企业用户了，则表示编辑
    // 否则 新建
    path: '/company/add',
    name: 'companyAdd',
    meta: {
      group: 'home'
    },
    component: () => import(/* webpackChunkName: "CompanyAdd" */ '../views/company')
  }
]
